<template>
  <!-- 2024.10.25 kouta.noborisaka 三井化学（市原工場）:ウィンドウ幅に応じて横スクロールを表示 -->
  <div style="overflow-x: auto">
    <!-- 2024.10.25 kouta.noborisaka 三井化学（市原工場）:PC表示の場合、要素の最小幅を設定 -->
    <v-container :class="{ 'scroll-area': calendarType == 'month' }">
      <v-container>
        <v-card flat>
          <v-row class="nopadding">
            <!--<v-col :cols="calendarType=='month'?2:12" class="noBotPadding" v-if="!domitoryStudentFlag">
            <RyouSelect :class="{ryouSelectPCStyle1:calendarType=='month',ryouSelectMobileStyle1:calendarType=='month'}"
                        :label="'物件グループ名選択'" :items="buildGroupOptionItems" :itemText="'build_group_name'"
                        :itemValue="'build_group_id'" v-model="buildGroupSelectValue" :value="buildGroupSelectValue">
            </RyouSelect>
          </v-col>-->
            <v-col
              :cols="calendarType == 'month' ? 2 : 12"
              class="noBotPadding"
              v-if="showGroupListFlg"
            >
              <RyouSelect
                :class="{
                  ryouSelectPCStyle1: calendarType == 'month',
                  ryouSelectMobileStyle1: calendarType == 'month',
                }"
                :label="'物件グループ名選択'"
                :items="buildGroupOptionItems"
                :itemText="'build_group_name'"
                :itemValue="'build_group_id'"
                v-model="buildGroupSelectValue"
                :value="buildGroupSelectValue"
              >
              </RyouSelect>
            </v-col>
            <v-col
              :cols="calendarType == 'month' ? 2 : 12"
              class="noBotPadding"
              v-if="!domitoryStudentFlag"
            >
              <RyouSelect
                :class="{
                  ryouSelectPCStyle1: calendarType == 'month',
                  ryouSelectMobileStyle1: calendarType == 'week',
                }"
                :label="'物件名選択'"
                :items="buildOptionItems"
                :itemText="'building_name'"
                :itemValue="'building_id'"
                v-model="buildSelectValue"
                :value="buildSelectValue"
              >
              </RyouSelect>
            </v-col>
          </v-row>
          <v-row class="nopadding" v-if="calendarType == 'month'">
            <v-col cols="5" class="noBotPadding noRigPadding">
              <v-row>
                <v-card-title style="height: 40px" v-if="!buildGroupSelectCtrl">
                  予約者
                </v-card-title>
                <v-col class="noBotPadding">
                  <RyouAutocomplete
                    class="ryouSelectPCStyle2"
                    :items="reserveUserOptionItems"
                    :itemText="'user_name'"
                    :itemValue="'user_id'"
                    v-model="reserveUserSelectValue"
                    :value="reserveUserSelectValue"
                    :disabled="reserveUserSelectCtrl"
                    v-if="!buildGroupSelectCtrl"
                  >
                  </RyouAutocomplete>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="5" class="noTopBotPadding">
              <v-toolbar flat class="noTopBotPadding">
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="calendarPrv"
                  :disabled="arrowCtrlFlag"
                >
                  <v-icon x-large> mdi-chevron-left </v-icon>
                </v-btn>
                <v-toolbar-title>
                  <h2>{{ this.canderTitle }}</h2>
                </v-toolbar-title>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="calendarNext"
                  :disabled="arrowCtrlFlag"
                >
                  <v-icon x-large> mdi-chevron-right </v-icon>
                </v-btn>
              </v-toolbar>
            </v-col>
            <v-col cols="2" class="noBotPadding">
              <!--<RyouSelect
              class="ryouSelectPCStyle3"
              :items="typeItem"
              :itemText="'typeText'"
              :itemValue="'typeValue'"
              v-model="typeSelectOptionValue"
              :value="typeSelectOptionValue"
              disabled
            >
            </RyouSelect>
            -->
            </v-col>
          </v-row>
          <v-row class="nopadding" v-if="calendarType == 'week'">
            <v-spacer></v-spacer>
            <v-col class="noTopBotPaddingMobile">
              <v-toolbar flat class="noTopBotPaddingMobile">
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="calendarPrv"
                  :disabled="arrowCtrlFlag"
                >
                  <v-icon x-large> mdi-chevron-left </v-icon>
                </v-btn>
                <v-toolbar-title>
                  <h5>{{ this.canderTitle }}</h5>
                </v-toolbar-title>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="calendarNext"
                  :disabled="arrowCtrlFlag"
                >
                  <v-icon x-large> mdi-chevron-right </v-icon>
                </v-btn>
              </v-toolbar>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-card>
      </v-container>
      <v-container>
        <!-- 2024.10.24 kouta.noborisaka 三井化学（市原工場）:高さ指定「height="540"」を削除 -->
        <v-sheet v-if="calendarType == 'month'">
          <!-- 2024.10.24 kouta.noborisaka 三井化学（市原工場）:メニュー名を省略表示しないように「:event-more="false"」を追加 -->
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-more="false"
            :type="calendarType"
            locale="ja-jp"
            @click:event="showEvent"
            @click:date="btnClick($event)"
          >
            <template v-slot:day="props">
              <template v-for="(ent, index) in notOfferEventsDateList">
                <div
                  :key="index"
                  class="disable"
                  v-if="ent == props.date"
                  style="text-align: center"
                >
                  提供無し
                </div>
              </template>
            </template>
            <template v-slot:event="{ event }">
              <!-- 2024.10.24 kouta.noborisaka 三井化学（市原工場）:PC表示でもメニュー名とチェックマークが見切れないように、<v-row :dense="calendarType == 'week'">をtrueに変更 -->
              <v-row :dense="true">
                <!-- 2024.10.24 kouta.noborisaka 三井化学（市原工場）:styleに「white-space: normal」を追加 -->
                <v-col
                  :cols="calendarType == 'month' ? 10 : 5"
                  style="text-align: center; white-space: normal"
                  v-if="notOfferEventsDateList.indexOf(event.start) == -1"
                >
                  {{
                    event.name == "" || event.name == null
                      ? event.meal_name
                      : event.name
                  }}
                </v-col>
                <v-col
                  :cols="calendarType == 'month' ? 2 : 7"
                  style="
                    background-color: #ffffff !important;
                    text-align: center;
                  "
                  v-if="notOfferEventsDateList.indexOf(event.start) == -1"
                >
                  <v-icon
                    small
                    color="blue"
                    v-if="event.before && event.checked && !event.hold"
                  >
                    mdi-check-circle
                  </v-icon>
                  <v-icon
                    small
                    color="green"
                    v-if="event.before && event.checked && event.hold"
                  >
                    mdi-check-circle
                  </v-icon>
                  <v-icon
                    small
                    color="blue"
                    v-if="!event.before && event.checked && !event.hold"
                  >
                    mdi-check-circle
                  </v-icon>
                  <v-icon
                    small
                    color="green"
                    v-if="!event.before && event.checked && event.hold"
                  >
                    mdi-check-circle
                  </v-icon>
                  <v-icon small v-if="!event.checked">
                    mdi-checkbox-blank-circle-outline
                  </v-icon>
                </v-col>
                <v-col
                  cols="12"
                  style="text-align: center"
                  v-if="
                    calendarType == 'week' &&
                    notOfferEventsDateList.indexOf(event.start) != -1
                  "
                >
                  {{
                    event.name == "" || event.name == null
                      ? event.meal_name
                      : event.name
                  }}
                </v-col>
              </v-row>
            </template>
          </v-calendar>
        </v-sheet>
        <v-sheet height="700" v-if="calendarType == 'week'">
          <!-- 2024.10.24 kouta.noborisaka 三井化学（市原工場）:メニュー名を省略表示しないように「:event-more="false"」を追加 -->
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-more="false"
            :type="calendarType"
            locale="ja-jp"
            @click:event="showEvent"
            @click:date="btnClick($event)"
          >
          </v-calendar>

          <template>
            <div v-for="day in weekDates" :key="day">
              <v-card
                class="pa-1"
                v-if="notOfferEventsDateList.includes(day)"
                color="#bebebe"
                min-height="50"
              >
                <v-row no-gutters align="center">
                  <v-col cols="5">
                    <v-card-text class="text-center pa-2">{{
                      dateFormat(day)
                    }}</v-card-text>
                  </v-col>
                  <v-col cols="7" v-if="notOfferEventsDateList.includes(day)">
                    <v-card-text class="text-center pa-2">提供無し</v-card-text>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="pa-1"
                @click="cardClick(day)"
                v-if="!notOfferEventsDateList.includes(day)"
                min-height="50"
              >
                <v-row no-gutters align="center">
                  <v-col cols="5">
                    <v-card-text class="text-center pa-2">{{
                      dateFormat(day)
                    }}</v-card-text>
                  </v-col>

                  <v-col cols="7">
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        v-for="item in weekEvents"
                        :key="item.id"
                      >
                        <v-row v-if="item.start == day">
                          <v-col cols="9">
                            <v-card
                              class="white--text"
                              outlined
                              tile
                              :color="item.color"
                              min-height="25"
                              >{{
                                item.name == "" || item.name == null
                                  ? item.meal_name
                                  : item.name
                              }}</v-card
                            >
                          </v-col>
                          <v-col cols="1">
                            <v-icon
                              small
                              color="blue"
                              v-if="item.before && item.checked && !item.hold"
                            >
                              mdi-check-circle
                            </v-icon>
                            <v-icon
                              small
                              color="green"
                              v-if="item.before && item.checked && item.hold"
                            >
                              mdi-check-circle
                            </v-icon>
                            <v-icon
                              small
                              color="blue"
                              v-if="!item.before && item.checked && !item.hold"
                            >
                              mdi-check-circle
                            </v-icon>
                            <v-icon
                              small
                              color="green"
                              v-if="!item.before && item.checked && item.hold"
                            >
                              mdi-check-circle
                            </v-icon>
                            <v-icon small v-if="!item.checked">
                              mdi-checkbox-blank-circle-outline
                            </v-icon>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </template>
        </v-sheet>
        <div v-if="PCDisp">
          <v-layout>
            <v-flex>
              <v-card-actions v-if="calendarType == 'month'">
                <RyouBlackBtn
                  :label="'一括登録'"
                  :disabled="collectiveBtnCtrl"
                  :handlerClick="collectiveReservation"
                >
                </RyouBlackBtn>
                <RyouBlackBtn
                  :label="'デフォルト予約'"
                  :disabled="collectiveBtnCtrl"
                  :handlerClick="defaultReservation"
                  :buildGroupId="buildGroupSelectValue"
                  :userId="reserveUserSelectValue"
                >
                </RyouBlackBtn>
              </v-card-actions>
              <v-card-text class="red--text text-h5" v-if="mealClaimMonthDisp">
                <!-- ～MM/ddまでの予約変更はMM/dd hh:mmまでに行ってください -->
                <div v-for="deadMsg in this.mealDeadLineMessage">
                  {{ deadMsg }}
                </div>
                <div>
                  残し食「<v-icon small color="green"> mdi-check-circle </v-icon
                  >」は夕食のみ有効です。
                </div>
              </v-card-text>
            </v-flex>
            <v-flex>
              <v-container>
                <table border="1" class="table_style" v-if="nskimitsuDisp">
                  <tbody>
                    <tr style="background-color: #64b5f6">
                      <th
                        class="white--text text-body-2"
                        style="width: 10%"
                        rowspan="0"
                      >
                        寮食費
                      </th>
                      <th
                        class="white--text text-body-2"
                        style="width: 40%"
                        colspan="2"
                      ></th>
                      <th
                        class="white--text text-body-2"
                        style="width: 15%"
                        colspan="2"
                      >
                        {{ this.mealClaimMonthDateBetweenFirst }}
                      </th>
                      <th
                        class="white--text text-body-2"
                        style="width: 15%"
                        colspan="2"
                      >
                        {{ this.mealClaimMonthDateBetweenSecond }}
                      </th>
                    </tr>
                    <tr>
                      <td class="text-body-2" style="width: 15%">基本料金</td>
                      <td></td>
                      <td></td>
                      <td class="text-body-2" align="right">
                        {{
                          this.mealClaimMonthMealBasicUnitPriceFirst.toLocaleString()
                        }}円
                      </td>
                      <td></td>
                      <td class="text-body-2" align="right">
                        {{
                          this.mealClaimMonthMealBasicUnitPriceSecond.toLocaleString()
                        }}円
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index) in this.mealClaimMonthItems"
                      :key="index"
                    >
                      <td class="text-body-2">
                        {{
                          index == 0 ? "喫食料金" : index == 1 ? "（実費）" : ""
                        }}
                      </td>
                      <td class="text-body-2">{{ item.meal_name }}</td>
                      <td class="text-body-2" align="right">
                        {{ item.total_num }}食
                      </td>
                      <td class="text-body-2" align="right">
                        {{ item.total_fee.toLocaleString() }}円
                      </td>
                      <td class="text-body-2" align="right">
                        {{ item.total_num2 }}食
                      </td>
                      <td class="text-body-2" align="right">
                        {{ item.total_fee2.toLocaleString() }}円
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td class="text-body-2" align="right">
                        {{
                          this.mealClaimMonthMealTotalPriceFirst.toLocaleString()
                        }}円
                      </td>
                      <td></td>
                      <td class="text-body-2" align="right">
                        {{
                          this.mealClaimMonthMealTotalPriceSecond.toLocaleString()
                        }}円
                      </td>
                    </tr>
                    <tr style="background-color: #64b5f6">
                      <th
                        class="white--text text-body-2"
                        style="width: 40%"
                        colspan="2"
                        align="left"
                      >
                        小計
                      </th>
                      <td></td>
                      <th
                        class="white--text text-body-2"
                        style="width: 15%"
                        align="right"
                      >
                        {{
                          this.mealClaimMonthSubTotalFirst.toLocaleString()
                        }}円
                      </th>
                      <td></td>
                      <th
                        class="white--text text-body-2"
                        style="width: 15%"
                        align="right"
                      >
                        {{
                          this.mealClaimMonthSubTotalSecond.toLocaleString()
                        }}円
                      </th>
                    </tr>
                  </tbody>
                </table>
              </v-container>
            </v-flex>
          </v-layout>
        </div>
        <div v-else>
          <v-card-actions v-if="calendarType == 'week'">
            <RyouBlackBtn
              :label="'一括登録'"
              :disabled="collectiveBtnCtrl"
              :handlerClick="collectiveReservation"
            >
            </RyouBlackBtn>
            <RyouBlackBtn
              :label="'デフォルト予約'"
              :disabled="collectiveBtnCtrl"
              :handlerClick="defaultReservation"
              :buildGroupId="buildGroupSelectValue"
              :userId="reserveUserSelectValue"
            >
            </RyouBlackBtn>
          </v-card-actions>
          <v-card-text class="red--text" v-if="mealClaimMonthDisp">
            <!-- ～MM/ddまでの予約変更はMM/dd hh:mmまでに行ってください -->
            <div v-for="deadMsg in this.mealDeadLineMessage">
              {{ deadMsg }}
            </div>
            <div>
              残し食「<v-icon small color="green"> mdi-check-circle </v-icon
              >」は夕食のみ有効です。
            </div>
          </v-card-text>
          <v-container>
            <table border="1" class="table_style" v-if="nskimitsuDisp">
              <tbody>
                <tr>
                  <td
                    class="white--text text-body-2"
                    style="background-color: #64b5f6; width: 30%"
                  >
                    {{ this.mealClaimMonthDateBetweenFirst }}
                  </td>
                  <td
                    class="white--text text-body-2"
                    style="background-color: #64b5f6; width: 30%"
                  >
                    喫食料金
                  </td>
                  <td class="text-body-2" align="right">
                    {{ this.mealClaimMonthSubTotalFirst.toLocaleString() }}円
                  </td>
                </tr>
                <tr>
                  <td
                    class="white--text text-body-2"
                    style="background-color: #64b5f6; width: 30%"
                  >
                    {{ this.mealClaimMonthDateBetweenSecond }}
                  </td>
                  <td
                    class="white--text text-body-2"
                    style="background-color: #64b5f6; width: 30%"
                  >
                    喫食料金
                  </td>
                  <td class="text-body-2" align="right">
                    {{ this.mealClaimMonthSubTotalSecond.toLocaleString() }}円
                  </td>
                </tr>
              </tbody>
            </table>
          </v-container>
        </div>
      </v-container>
      <MealReservationDayDialog
        ref="modalDayReservation"
        @reCalendar="calendarGet"
        @reCalc="getMealClaimMonthCost"
      ></MealReservationDayDialog>
      <!-- 2024.11.25 kouta.noborisaka 三井化学（市原工場）:食事予約（一括）のポップアップを閉じたときに、寮食費計算の表を再取得する -->
      <MealReservationCollectiveDialog
        ref="modalCollectiveReservation"
        @reCalendar="calendarGet"
        @reCalc="getMealClaimMonthCost"
      ></MealReservationCollectiveDialog>
      <MealReservationDefaultDialog
        ref="modalDefaultReservation"
      ></MealReservationDefaultDialog>
    </v-container>
  </div>
</template>

<script>
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouSelect from "../../components/formInput/RyouSelect";
import RyouAutocomplete from "../../components/formInput/RyouAutocomplete";
import MealReservationDayDialog from "./modules/MealReservationDayDialog.vue";
import MealReservationCollectiveDialog from "./modules/MealReservationCollectiveDialog.vue";
import MealReservationDefaultDialog from "./modules/MealReservationDefaultDialog.vue";
import { data } from "jquery";
export default {
  name: "MealReservation",
  components: {
    RyouBlackBtn,
    RyouSelect,
    RyouAutocomplete,
    MealReservationDayDialog,
    MealReservationCollectiveDialog,
    MealReservationDefaultDialog,
  },
  data() {
    return {
      domitoryStudentFlag: false,
      showGroupListFlg: true,
      p2Form: true,
      focus: "",
      calendarType: null,
      typeSelectOptionValue: null,
      typeItem: [],
      buildGroupSelectCtrl: null,
      reserveUserSelectCtrl: null,
      collectiveBtnCtrl: null,
      canderTitle: "", //カレンダーのヘッダ
      mealDeadLineDay: "", //締め切りの日
      mealDeadLineMessage: [], //食事締め切り表示文言
      mealHoldReserveMessage1: "残し食「〇」は夕食のみ有効です。", //食事予約（取り置き）のメッセージ１
      hasEventsDateList: [], //メニューが存在する日付["YYYY-MM-dd","YYYY-MM-dd",...]
      hasEventsDateDetailedDataList: [], //メニューが存在する詳細データ
      mealClasses: [],
      mealNameClassReserve: [], //日付の食事区分、食事名["1"＆食事一＆true,"2"＆食事二&false,...]
      events: [], //メニューが存在毎日のイベント[ある日の食事一,食事二,...]
      notOfferEventsDateList: [], //提供無し日付["YYYY-MM-dd","YYYY-MM-dd",...]
      notOfferEventsDateDetailedDataList: [], //提供無し日付詳細データ
      nskimitsuDisp: false, // 日鉄物流表示用（それ毎に表示）
      buildGroupSelectValue: "",
      buildGroupOptionItems: [],
      buildSelectValue: "",
      buildOptionItems: [],
      inDomitoryDate: null,
      reserveUserSelectValue: "",
      reserveUserOptionItems: [],
      reserveUserIndomitoryItems: [],
      thisSunday: "",
      colors: [
        "#FF9800", //オレンジ
        "#673AB7", //深紫
        "#4CAF50", //緑
        "#E91E63", //ピンク
        "#3F51B5", //インディゴ
        "#009688", //teal
        "#FF5722", //深オレンジ
        "#8BC34A", //light-green
        "#D32F2F", //red darken-2
        "#1565C0", //blue darken-3
      ],
      days: ["(日)", "(月)", "(火)", "(水)", "(木)", "(金)", "(土)"],
      weekDates: [],
      arrowCtrlFlag: false,
      PCDisp: true,
      mealClaimMonthDisp: false,
      mealClaimMonthItems: [],
      mealClaimMonthDateBetweenFirst: "",
      mealClaimMonthMealBasicUnitPriceFirst: 0,
      mealClaimMonthMealTotalPriceFirst: 0,
      mealClaimMonthSubTotalFirst: 0,
      mealClaimMonthDateBetweenSecond: "",
      mealClaimMonthMealBasicUnitPriceSecond: 0,
      mealClaimMonthMealTotalPriceSecond: 0,
      mealClaimMonthSubTotalSecond: 0,
    };
  },
  created() {
    this.machineModelCheck();
    this.initData();
    this.reserveUserSelectCtrl = true;
    if (this.$store.getters.getUserClass == "3") {
      this.buildGroupSelectCtrl = true;
      this.collectiveBtnCtrl = false;
    } else {
      this.collectiveBtnCtrl = true;
    }
  },
  mounted() {
    this.canderTitle = this.initCanderValue(this.$refs.calendar.title);

    if (this.calendarType == "week") {
      this.$("div.v-calendar-daily__head").remove();
      this.$("div.v-calendar-daily__body").remove();
      this.$("div.v-calendar-daily__intervals-head").remove();
      this.$(".v-sheet.theme--light").height("auto");
      this.smallCalendarWeekListStyle();

      //処理日の日付を取得
      var dt = new Date();
      let day_num = dt.getDay();
      dt.setDate(dt.getDate() - day_num);
      this.thisSunday = dt;
    }
  },
  watch: {
    buildGroupSelectValue(value) {
      this.reserveUserSelectValue = "";
      this.buildSelectValue = "";
      this.calendarDataClear();
      this.mealClassDeadLineGet();
      // 表示フラグOFF
      this.nskimitsuDisp = false;

      if (this.$store.getters.getUserClass == "3") {
        this.calendarGet();
        this.getMealClaimMonthCost(true);
      } else {
        let params = {
          buildGroupId: value,
        };

        //物件一覧を取得
        this.getRequest(
          "/mealReservation/buildingGet",
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success && data.status == "200") {
            //this.reserveUserSelectCtrl = false;
            var mapDatas = data.result.map((item) => {
              item.building_id = String(item.building_id);
              return item;
            });
            this.buildOptionItems = mapDatas;
            // this.buildOptionItems.push(this.buildSelectValue);
            // 物件を初期選択とする
            if (mapDatas.length != 0) {
              this.buildSelectValue = mapDatas[0].building_id;
            }
          }
        });

        //物件選択が空の場合はグループに紐づくユーザを取得する
        if (this.buildSelectValue == "") {
          //selectBoxで値を取る
          this.getRequest(
            "/mealReservation/reserveUserGet",
            params,
            this.$store.getters.getUserToken
          ).then((data) => {
            if (data.success && data.status == "200") {
              this.reserveUserSelectCtrl = false;
              var mapDatas = data.result.map((item) => {
                item.user_name = item.user_id + "　" + item.user_name;
                return item;
              });
              this.reserveUserOptionItems = mapDatas;
              // 寮生利用者
              this.reserveUserIndomitoryItems = data.result;
            }
          });
        }
      }
    },
    buildSelectValue(value) {
      this.reserveUserSelectValue = "";
      this.calendarDataClear();
      this.mealClassDeadLineGet();
      let params;
      this.nskimitsuDisp = false;

      //物件が選択されている場合は物件で検索
      if (value != "" && value != null) {
        params = {
          buildGroupId: this.buildGroupSelectValue,
          buildingId: value,
        };
      } else {
        //物件が選択されていない場合はグループで検索
        params = {
          buildGroupId: this.buildGroupSelectValue,
        };
      }

      this.getRequest(
        "/mealReservation/reserveUserGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success && data.status == "200") {
          this.reserveUserSelectCtrl = false;
          var mapDatas = data.result.map((item) => {
            item.user_name = item.user_id + "　" + item.user_name;
            return item;
          });
          this.reserveUserOptionItems = mapDatas;
          //
          this.reserveUserIndomitoryItems = data.result;
        }
      });
    },
    reserveUserSelectValue(value) {
      if (value != "") {
        this.collectiveBtnCtrl = false;
        this.nskimitsuDisp = true;
        this.calendarGet();
        this.getMealClaimMonthCost(true);
      } else {
        if (this.$store.getters.getUserClass == "3") {
          this.collectiveBtnCtrl = false;
          this.getMealClaimMonthCost(true);
        } else {
          this.collectiveBtnCtrl = true;
          this.getMealClaimMonthCost(false);
        }
      }
    },
  },
  computed: {
    weekEvents() {
      if (this.weekDates.length != 0) {
        return this.events.filter((item) =>
          this.weekDates.includes(item.start)
        );
      }
      return this.events;
    },
  },
  methods: {
    smallCalendarWeekListStyle() {
      this.$(".v-btn--fab.v-size--default").addClass(
        "smallCalendarWeekListStyle"
      );
    },
    //日付をクリック
    btnClick(date) {
      if (this.calendarType == "month") {
        let getNowMonth = this.$refs.calendar.title.split("月 ");
        // 当月かどうかを判断
        if (date.month == getNowMonth[0]) {
          this.btnClickOpen(date);
        } else {
          setTimeout(() => {
            this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
            this.calendarGet();
            if (
              (this.reserveUserSelectValue != null &&
                this.reserveUserSelectValue != "") ||
              this.$store.getters.getUserClass == "3"
            ) {
              this.getMealClaimMonthCost(true);
            }
          }, 100);
        }
      } else {
        this.btnClickOpen(date);
      }
    },
    btnClickOpen(date) {
      // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:総務または管理人の場合、食事予約締め切り後の月次締め処理前であれば予約ポップアップを表示 Start
      // if (
      //   this.$store.getters.getUserClass == "1" ||
      //   this.$store.getters.getUserClass == "2"
      // ) {
      //   let DialogData = this.calendarDialogDataGet(date.date);
      //   if (DialogData && DialogData[date.date].length) {
      //     if (DialogData[date.date][0].month_close_flg == "0") {
      //       this.$refs.modalDayReservation.getInputValue(
      //         DialogData,
      //         this.buildGroupSelectValue,
      //         this.reserveUserSelectValue,
      //         this.calendarType
      //       );
      //     } else {
      //       this.$toast.open({
      //         message: "月締めを過ぎた食事予約データのため、変更できません。",
      //         type: "error",
      //       });
      //     }
      //   }
      //   // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:総務または管理人の場合、食事予約締め切り後の月次締め処理前であれば予約ポップアップを表示 End
      // } else
       if (!(date.date < this.mealDeadLineDay)) {
        let DialogData = this.calendarDialogDataGet(date.date);
        if (DialogData) {
          // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:パラメータ4:カレンダータイプを追加 Start
          // パラメータ1:ダイアログデータ、パラメータ2:物件グループID、パラメータ3:ユーザID、パラメータ4:カレンダータイプ
          if (this.$store.getters.getUserClass == "3") {
            this.$refs.modalDayReservation.getInputValue(
              DialogData,
              this.buildGroupSelectValue,
              this.$store.getters.getUserId,
              this.calendarType
            );
          } else {
            this.$refs.modalDayReservation.getInputValue(
              DialogData,
              this.buildGroupSelectValue,
              this.reserveUserSelectValue,
              this.calendarType
            );
          }
        }
        // 2024.10.31 kouta.noborisaka 三井化学（市原工場）:当日取り置きは仕様外のためコメントアウト
        // } else {
        //   // 今日だけは許可するように修正
        //   let today = new Date();
        //   if (
        //     date.year === today.getFullYear() &&
        //     date.month === today.getMonth() + 1 &&
        //     date.day === today.getDate()
        //   ) {
        //     let DialogData = this.calendarDialogDataGet(date.date);
        //     if (DialogData) {
        //       // パラメータ1:ダイアログデータ、パラメータ2:物件グループID、パラメータ3:ユーザID、パラメータ4:カレンダータイプ
        //       if (this.$store.getters.getUserClass == "3") {
        //         this.$refs.modalDayReservation.getInputValue(
        //           DialogData,
        //           this.buildGroupSelectValue,
        //           this.$store.getters.getUserId,
        //           this.calendarType
        //         );
        //       } else {
        //         this.$refs.modalDayReservation.getInputValue(
        //           DialogData,
        //           this.buildGroupSelectValue,
        //           this.reserveUserSelectValue,
        //           this.calendarType
        //         );
        //       }
        //       // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:パラメータ4:カレンダータイプを追加 End
        //     }
        //   }
      }
    },
    //イベントクリック
    showEvent(event) {
      // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:総務または管理人の場合、食事予約締め切り後の月次締め処理前であれば予約ポップアップを表示 Start
      // if (
      //   this.$store.getters.getUserClass == "1" ||
      //   this.$store.getters.getUserClass == "2"
      // ) {
      //   let DialogData = this.calendarDialogDataGet(event.day.date);
      //   if (DialogData && DialogData[event.day.date].length) {
      //     if (DialogData[event.day.date][0].month_close_flg == "0") {
      //       this.$refs.modalDayReservation.getInputValue(
      //         DialogData,
      //         this.buildGroupSelectValue,
      //         this.reserveUserSelectValue,
      //         this.calendarType
      //       );
      //     } else {
      //       this.$toast.open({
      //         message: "月締めを過ぎた食事予約データのため、変更できません。",
      //         type: "error",
      //       });
      //     }
      //   }
      //   // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:総務または管理人の場合、食事予約締め切り後の月次締め処理前であれば予約ポップアップを表示 End
      // } else 
      if (!(event.day.date < this.mealDeadLineDay)) {
        let DialogData = this.calendarDialogDataGet(event.day.date);
        if (DialogData) {
          // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:パラメータ4:カレンダータイプを追加 Start
          // パラメータ1:ダイアログデータ、パラメータ2:物件グループID、パラメータ3:ユーザID、パラメータ4:カレンダータイプ
          if (this.$store.getters.getUserClass == "3") {
            this.$refs.modalDayReservation.getInputValue(
              DialogData,
              this.buildGroupSelectValue,
              this.$store.getters.getUserId,
              this.calendarType
            );
          } else {
            this.$refs.modalDayReservation.getInputValue(
              DialogData,
              this.buildGroupSelectValue,
              this.reserveUserSelectValue,
              this.calendarType
            );
          }
          // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:パラメータ4:カレンダータイプを追加 End
        }
      }
    },
    //週カレンダーのカードをクリック
    cardClick(date) {
      if (!(date < this.mealDeadLineDay)) {
        let DialogData = this.calendarDialogDataGet(date);
        // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:パラメータ4:カレンダータイプを追加 Start
        if (DialogData) {
          this.$refs.modalDayReservation.getInputValue(
            DialogData,
            this.buildGroupSelectValue,
            this.$store.getters.getUserId,
            this.calendarType
          );
        }
        // 2024.10.31 kouta.noborisaka 三井化学（市原工場）:当日取り置きは仕様外のためコメントアウト
        // } else {
        //   // 今日だけは許可するように修正
        //   // スマホの場合このdateにオブジェクトで設定されていない。dateにはyyyy-mm-ddとなっている。
        //   let today = new Date();
        //   let compdate = new Date(
        //     parseInt(date.substring(0, 4)),
        //     parseInt(date.substring(5, 7)) - 1,
        //     parseInt(date.substring(8, 10))
        //   );
        //   if (
        //     compdate.getFullYear() === today.getFullYear() &&
        //     compdate.getMonth() === today.getMonth() &&
        //     compdate.getDate() === today.getDate()
        //   ) {
        //     let DialogData = this.calendarDialogDataGet(date);
        //     if (DialogData) {
        //       this.$refs.modalDayReservation.getInputValue(
        //         DialogData,
        //         this.buildGroupSelectValue,
        //         this.$store.getters.getUserId,
        //         this.calendarType
        //       );
        //     }
        //   }
        // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:パラメータ4:カレンダータイプを追加 End
      }
    },
    mealNameClassReserveGet() {
      let that = this;
      this.mealClasses.forEach((item) => {
        let mealNameClassReserveItem = {
          meal_class: item.meal_class,
          meal_name: item.meal_name,
          limit_time: item.limit_time,
          reserve_flg: false,
          holding_flg: false,
        };

        that.mealNameClassReserve.push(mealNameClassReserveItem);
      });
      return that.mealNameClassReserve;
    },
    collectiveReservation() {
      var d1 = new Date(this.mealDeadLineDay);
      var d2 = new Date(this.inDomitoryDate);
      let setDealLineDay = this.mealDeadLineDay;
      if (d1 < d2) {
        setDealLineDay = this.inDomitoryDate;
      }
      if (this.$store.getters.getUserClass == "3") {
        this.$refs.modalCollectiveReservation.getInputValue(
          this.mealNameClassReserveGet(),
          this.buildGroupSelectValue,
          this.$store.getters.getUserId,
          setDealLineDay
        );
      } else {
        this.$refs.modalCollectiveReservation.getInputValue(
          this.mealNameClassReserveGet(),
          this.buildGroupSelectValue,
          this.reserveUserSelectValue,
          setDealLineDay
        );
      }
    },
    defaultReservation() {
      var userId;
      if (this.$store.getters.getUserClass == "3") {
        userId = this.$store.getters.getUserId;
      } else {
        userId = this.reserveUserSelectValue;
      }
      this.$refs.modalDefaultReservation.open(
        this.buildGroupSelectValue,
        userId
      );
    },
    machineModelCheck() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );

      if (flag === null || flag === undefined || flag === "") {
        this.typeItem = [{ typeValue: "1", typeText: "月" }];
        this.typeSelectOptionValue = "1";
        this.calendarType = "month";
      } else {
        this.typeItem = [{ typeValue: "2", typeText: "週" }];
        this.typeSelectOptionValue = "2";
        this.calendarType = "week";
      }
    },
    initData() {
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      //selectBoxで値を取る
      this.getRequest(
        "/mealReservation/buildGroupGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success && data.status == "200") {
          this.buildGroupOptionItems = data.result;
          if (this.$store.getters.getUserClass == "3") {
            this.buildGroupSelectValue =
              this.buildGroupOptionItems[0].build_group_id;
            this.domitoryStudentFlag = true;
            if (this.buildGroupOptionItems.length <= 1) {
              this.showGroupListFlg = false;
            }
          } else {
            if (this.$store.getters.getBuilGroupId != null) {
              this.buildGroupSelectValue = this.$store.getters.getBuilGroupId;
            }
          }
        }
      });
    },
    calendarDataClear() {
      // データクリア
      this.mealNameClassReserve = [];
      this.events = [];
      this.hasEventsDateList = [];
      this.hasEventsDateDetailedDataList = [];
      this.notOfferEventsDateList = [];
      this.notOfferEventsDateDetailedDataList = [];
      this.$(".v-calendar-weekly__day:has(div.disable)").removeClass("mask");
      this.$("div.disable").remove();
    },
    // 食事締め切り日取得
    mealClassDeadLineGet() {
      let that = this;
      let mealClassDeadLineParams = {
        buildGroupId: this.buildGroupSelectValue,
      };

      this.getRequest(
        "/mealReservation/mealClassGet",
        mealClassDeadLineParams,
        this.$store.getters.getUserToken
      ).then((data) => {
        // 食事区分取得
        if (data.success) {
          that.mealClasses = data.result;
        }
      });

      this.getRequest(
        "/mealReservation/mealDeadLineGet",
        mealClassDeadLineParams,
        this.$store.getters.getUserToken
      ).then((data) => {
        // 食事締め切り日取得
        if (data.success) {
          that.mealDeadLineDay = data.result;
        }
      });

      this.getRequest(
        "/mealReservation/mealDeadLineMessageGet",
        mealClassDeadLineParams,
        this.$store.getters.getUserToken
      ).then((data) => {
        // 食事締め切り表示文言取得
        if (data.success && data.status == "200") {
          that.mealDeadLineMessage = data.result;
        }
      });
    },
    //カレンダーデータ取得
    calendarGet() {
      this.calendarDataClear();

      if (
        (this.reserveUserSelectValue != null &&
          this.reserveUserSelectValue != "") ||
        this.$store.getters.getUserClass == "3"
      ) {
        let that = this;
        let calendarParams = null;

        let queryUserId = null;

        if (this.$store.getters.getUserClass == "3") {
          queryUserId = this.$store.getters.getUserId;
        } else {
          queryUserId = this.reserveUserSelectValue;
        }

        if (this.$refs.calendar.title.split("月").length == 3) {
          let title = this.$refs.calendar.title;
          //"11月-12月2021"
          //"12月2021-1月2022"
          title = title.replace(/ /g, "");

          //["11", "-12", "2021"]
          //["12", "2021-1", "2022"]
          let firstSplitResult = title.split("月");
          let firstMonth = firstSplitResult[0];

          //["", "12"]
          //["2021", "1"]
          let secondSplitResult = firstSplitResult[1].split("-");

          if (secondSplitResult[0] != "") {
            calendarParams = {
              buildGroupId: this.buildGroupSelectValue,
              currentYM1: secondSplitResult[0] + "-" + firstMonth,
              currentYM2: firstSplitResult[2] + "-" + secondSplitResult[1],
              userId: queryUserId,
            };
          } else {
            calendarParams = {
              buildGroupId: this.buildGroupSelectValue,
              currentYM1: firstSplitResult[2] + "-" + firstMonth,
              currentYM2: firstSplitResult[2] + "-" + secondSplitResult[1],
              userId: queryUserId,
            };
          }
        } else {
          //年月取得
          let titleYear = this.canderTitle.split("年");
          let titleMonth = titleYear[1].split("月");
          calendarParams = {
            buildGroupId: this.buildGroupSelectValue,
            currentYM1: titleYear[0] + "-" + titleMonth[0],
            currentYM2: null,
            userId: queryUserId,
          };
        }

        this.arrowCtrlFlag = true;

        this.getRequest(
          "/mealReservation/calendarReserveGet",
          calendarParams,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success) {
            // 現在の月を循環
            for (
              let dateIndex = 0;
              dateIndex < data.result.length;
              dateIndex++
            ) {
              //取得当日
              let dateItem = data.result[dateIndex];

              // 取得当日(Key,Value)
              for (let dateKey in dateItem) {
                //取得当日データ
                let dateData = dateItem[dateKey];

                // 取得当日データあり
                if (dateData.length != 0) {
                  // データが存在する日付
                  if (dateData[0].offer_flg == "1") {
                    //食事提供あり結果セット
                    if (that.hasEventsDateList.indexOf(dateKey) < 0) {
                      that.hasEventsDateList.push(dateKey);
                      that.hasEventsDateDetailedDataList.push(dateItem);
                    }
                  } else if (dateData[0].offer_flg == "0") {
                    //食事提供なし結果セット
                    if (that.notOfferEventsDateList.indexOf(dateKey) < 0) {
                      that.notOfferEventsDateList.push(dateKey);
                      that.notOfferEventsDateDetailedDataList.push(dateItem);
                    }
                  }
                }
              }
            }

            this.getValue();
          }
          this.arrowCtrlFlag = false;
        });
      }
    },
    //カレンダー、ポップアップ、データ取得
    calendarDialogDataGet(value) {
      var date1 = new Date(value);
      var date2 = new Date(this.inDomitoryDate);
      if (date1 < date2) {
        return false;
      }

      for (
        let hedddIndex = 0;
        hedddIndex < this.hasEventsDateDetailedDataList.length;
        hedddIndex++
      ) {
        let hedddItem = this.hasEventsDateDetailedDataList[hedddIndex];

        for (let hedddKey in hedddItem) {
          if (hedddKey == value) {
            return hedddItem;
          }
        }
      }
    },
    //カレンダーヘッドの初期化時間
    initCanderValue(title) {
      //"12月2021"
      //"11月-12月2021"
      //"12月2021-1月2022"
      title = title.replace(/ /g, "");

      let newTitile = null;
      if (title.split("月").length == 3) {
        //["11", "-12", "2021"]
        //["12", "2021-1", "2022"]
        let firstSplitResult = title.split("月");
        let firstMonth = firstSplitResult[0];

        //["", "12"]
        //["2021", "1"]
        let secondSplitResult = firstSplitResult[1].split("-");

        if (secondSplitResult[0] != "") {
          newTitile =
            secondSplitResult[0] +
            "年" +
            firstMonth +
            "月" +
            "～" +
            secondSplitResult[1] +
            "月";
        } else {
          newTitile =
            firstSplitResult[2] +
            "年" +
            firstMonth +
            "月" +
            "～" +
            secondSplitResult[1] +
            "月";
        }
      } else {
        let titleList = title.split("月");
        newTitile = titleList[1] + "年" + titleList[0] + "月";
      }
      return newTitile;
    },
    //カレンダーの来月
    calendarNext() {
      this.$refs.calendar.next();

      setTimeout(() => {
        if (this.calendarType == "week") {
          this.smallCalendarWeekListStyle();
          this.thisSunday.setDate(this.thisSunday.getDate() + 7); //週表示の場合は次の日曜日を取得
        }
        this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
        this.calendarGet();
        if (
          (this.reserveUserSelectValue != null &&
            this.reserveUserSelectValue != "") ||
          this.$store.getters.getUserClass == "3"
        ) {
          this.getMealClaimMonthCost(true);
        }
      }, 10);
    },
    //カレンダーの前の月
    calendarPrv() {
      this.$refs.calendar.prev();

      setTimeout(() => {
        if (this.calendarType == "week") {
          this.smallCalendarWeekListStyle();
          this.thisSunday.setDate(this.thisSunday.getDate() - 7); //週表示の場合は前の日曜日を取得
        }
        this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
        this.calendarGet();
        if (
          (this.reserveUserSelectValue != null &&
            this.reserveUserSelectValue != "") ||
          this.$store.getters.getUserClass == "3"
        ) {
          this.getMealClaimMonthCost(true);
        }
      }, 10);
    },
    //カレンダーデータのロードが完了しました。
    getValue() {
      // データが存在する、メニュー表示
      for (
        let hedddIndex = 0;
        hedddIndex < this.hasEventsDateDetailedDataList.length;
        hedddIndex++
      ) {
        let hasEventsDateDetailedDataItem =
          this.hasEventsDateDetailedDataList[hedddIndex];

        // 今日の日付設定
        let today = new Date();

        // 年・月・日・曜日を取得
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        const date = today.getDate();
        let checkDay = new Date(year, month, date);

        for (let hedddKey in hasEventsDateDetailedDataItem) {
          let hasEventsDateDetailedDataItemMenu =
            hasEventsDateDetailedDataItem[hedddKey];

          for (
            let hedddimIndex = 0;
            hedddimIndex < hasEventsDateDetailedDataItemMenu.length;
            hedddimIndex++
          ) {
            // 食事の締切日より前は予約させない
            // 今日だけは無視
            const hedddKeyDay = new Date(hedddKey);
            // 2024.10.31 kouta.noborisaka 三井化学（市原工場）:当日取り置きは仕様外のためコメントアウト
            // const hedYear = hedddKeyDay.getFullYear();
            // const hedMonth = hedddKeyDay.getMonth() + 1;
            // const hedDate = hedddKeyDay.getDate();
            // let heaCheckDay = new Date(hedYear, hedMonth, hedDate);
            // if (
            //   checkDay.getFullYear() === heaCheckDay.getFullYear() &&
            //   checkDay.getMonth() === heaCheckDay.getMonth() &&
            //   checkDay.getDate() === heaCheckDay.getDate()
            // ) {
            //   this.events.push({
            //     name: hasEventsDateDetailedDataItemMenu[hedddimIndex].menu,
            //     start: hedddKey,
            //     color:
            //       hasEventsDateDetailedDataItemMenu[hedddimIndex]
            //         .offer_flg_mc == "1"
            //         ? this.colors[hedddimIndex]
            //         : "#bebebe",
            //     //color: this.colors[hedddimIndex],
            //     timed: false,
            //     before: false,
            //     checked: Number(
            //       hasEventsDateDetailedDataItemMenu[hedddimIndex].reserve_flg
            //     ),
            //     hold: Number(
            //       hasEventsDateDetailedDataItemMenu[hedddimIndex].holding_flg
            //     ),
            //     days: this.days[new Date(hedddKey).getDay()],
            //     meal_name:
            //       hasEventsDateDetailedDataItemMenu[hedddimIndex].meal_name,
            //   });
            // } else
            if (hedddKey < this.mealDeadLineDay) {
              this.events.push({
                name: hasEventsDateDetailedDataItemMenu[hedddimIndex].menu,
                start: hedddKey,
                color:
                  hasEventsDateDetailedDataItemMenu[hedddimIndex]
                    .offer_flg_mc == "1"
                    ? "#795548"
                    : "#bebebe",
                //color: "#795548",
                timed: false,
                before: true,
                checked: Number(
                  hasEventsDateDetailedDataItemMenu[hedddimIndex].reserve_flg
                ),
                hold: Number(
                  hasEventsDateDetailedDataItemMenu[hedddimIndex].holding_flg
                ),
                days: this.days[new Date(hedddKey).getDay()],
                meal_name:
                  hasEventsDateDetailedDataItemMenu[hedddimIndex].meal_name,
              });
            } else {
              // 入寮日より前は予約させない
              if (
                hasEventsDateDetailedDataItemMenu[hedddimIndex]
                  .check_reserve_flg == "0"
              ) {
                this.events.push({
                  name: hasEventsDateDetailedDataItemMenu[hedddimIndex].menu,
                  start: hedddKey,
                  color:
                    hasEventsDateDetailedDataItemMenu[hedddimIndex]
                      .offer_flg_mc == "1"
                      ? "#795548"
                      : "#bebebe",
                  //color: this.colors[hedddimIndex],
                  timed: false,
                  before: true,
                  checked: Number(
                    hasEventsDateDetailedDataItemMenu[hedddimIndex].reserve_flg
                  ),
                  hold: Number(
                    hasEventsDateDetailedDataItemMenu[hedddimIndex].holding_flg
                  ),
                  days: this.days[new Date(hedddKey).getDay()],
                  meal_name:
                    hasEventsDateDetailedDataItemMenu[hedddimIndex].meal_name,
                });
              } else {
                this.events.push({
                  name: hasEventsDateDetailedDataItemMenu[hedddimIndex].menu,
                  start: hedddKey,
                  color:
                    hasEventsDateDetailedDataItemMenu[hedddimIndex]
                      .offer_flg_mc == "1"
                      ? this.colors[hedddimIndex]
                      : "#bebebe",
                  //color: this.colors[hedddimIndex],
                  timed: false,
                  before: false,
                  checked: Number(
                    hasEventsDateDetailedDataItemMenu[hedddimIndex].reserve_flg
                  ),
                  hold: Number(
                    hasEventsDateDetailedDataItemMenu[hedddimIndex].holding_flg
                  ),
                  days: this.days[new Date(hedddKey).getDay()],
                  meal_name:
                    hasEventsDateDetailedDataItemMenu[hedddimIndex].meal_name,
                });
              }
            }
          }
        }
      }
      if (this.calendarType == "week") {
        for (
          let index = 0;
          index < this.notOfferEventsDateList.length;
          index++
        ) {
          this.events.push({
            name: "提供無し",
            start: this.notOfferEventsDateList[index],
            color: "#bebebe",
            timed: false,
          });
        }
      }

      if (this.calendarType == "week") {
        this.setWeeks();
      }

      setTimeout(() => {
        // disableを含む要素を見つけて、スタイルを追加します
        this.$(".v-calendar-weekly__day:has(div.disable)").addClass("mask");
      }, 100);
    },
    //基準の日曜日から一週間の日付を取得
    setWeeks() {
      this.weekDates = [];
      var sunday = new Date(this.thisSunday.valueOf());
      for (var i = 0; i < 7; i++) {
        if (i != 0) {
          sunday.setDate(sunday.getDate() + 1);
        }

        var y = sunday.getFullYear();
        var m = sunday.getMonth() + 1;
        var m2 = ("00" + m).slice(-2); //0パディング
        var d = ("00" + sunday.getDate()).slice(-2);
        var date = y + "-" + m2 + "-" + d;

        this.weekDates.push(date);
      }
    },
    //日付を成型（mm/dd（曜日））
    dateFormat(value) {
      var date = new Date(value);
      var ret =
        date.getMonth() +
        1 +
        "月" +
        date.getDate() +
        "日" +
        this.days[date.getDay()];
      return ret;
    },
    getCurrentDate() {
      var date = new Date();
      var ret = date.getMonth() + 1 + "/" + date.getDate();
      return ret;
    },
    getMealClaimMonthCost(value) {
      if (value) {
        let buildingId = 0;
        if (this.buildSelectValue != "") {
          buildingId = this.buildSelectValue;
        }
        let queryUserId = null;
        if (this.$store.getters.getUserClass == "3") {
          buildingId = 0;
          queryUserId = this.$store.getters.getUserId;
        } else {
          queryUserId = this.reserveUserSelectValue;
        }

        let params = {
          building_id: buildingId,
          user_id: queryUserId,
          build_group_id: this.buildGroupSelectValue,
        };
        if (this.calendarType == "week") {
          var sunday = new Date(this.thisSunday.valueOf());
          params.year = sunday.getFullYear();
          params.month = sunday.getMonth() + 1;
          params.day = sunday.getDate();
        } else {
          let titleYear = this.canderTitle.split("年");
          let titleMonth = titleYear[1].split("月");
          params.year = Number(titleYear[0]);
          params.month = Number(titleMonth[0]);
          params.day = 1;
        }

        this.getRequest(
          "/mealReservation/getMealClaimMonthCost",
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success && data.status == "200") {
            this.inDomitoryDate = data.result.inDormitoryDate;
            let flag = navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            if (flag === null || flag === undefined || flag === "") {
              this.mealClaimMonthItems = data.result.mealClaimMonthJoho;
              this.mealClaimMonthDateBetweenFirst =
                data.result.monthFirst +
                "月" +
                "(" +
                data.result.startDateFirst +
                "～" +
                data.result.endDateFirst +
                ")";
              this.mealClaimMonthMealBasicUnitPriceFirst =
                data.result.mealBasicUnitPriceFirst;
              this.mealClaimMonthMealTotalPriceFirst =
                data.result.mealTotalPriceFirst;
              this.mealClaimMonthSubTotalFirst = data.result.subTotalFirst;
              this.mealClaimMonthDateBetweenSecond =
                data.result.monthSecond +
                "月" +
                "(" +
                data.result.startDateSecond +
                "～" +
                data.result.endDateSecond +
                ")";
              this.mealClaimMonthMealBasicUnitPriceSecond =
                data.result.mealBasicUnitPriceSecond;
              this.mealClaimMonthMealTotalPriceSecond =
                data.result.mealTotalPriceSecond;
              this.mealClaimMonthSubTotalSecond = data.result.subTotalSecond;
              this.PCDisp = true;
            } else {
              this.mealClaimMonthDateBetweenFirst =
                data.result.monthFirst + "月";
              //this.mealClaimMonthDateBetweenFirst = data.result.monthFirst + "月" + "(" + data.result.startDateFirst + "～" + data.result.endDateFirst + ")";
              this.mealClaimMonthSubTotalFirst = data.result.subTotalFirst;
              this.mealClaimMonthDateBetweenSecond =
                data.result.monthSecond + "月";
              //this.mealClaimMonthDateBetweenSecond = data.result.monthSecond + "月" + "(" + data.result.startDateSecond + "～" + data.result.endDateSecond + ")";
              this.mealClaimMonthSubTotalSecond = data.result.subTotalSecond;
              this.PCDisp = false;
            }
            this.mealClaimMonthDisp = true;
          }
        });
      } else {
        this.mealClaimMonthDisp = false;
        this.mealClaimMonthItems = [];
        this.mealClaimMonthDateBetweenFirst = "";
        this.mealClaimMonthMealBasicUnitPriceFirst = 0;
        this.mealClaimMonthMealTotalPriceFirst = 0;
        this.mealClaimMonthSubTotalFirst = 0;
        this.mealClaimMonthDateBetweenSecond = "";
        this.mealClaimMonthMealBasicUnitPriceSecond = 0;
        this.mealClaimMonthMealTotalPriceSecond = 0;
        this.mealClaimMonthSubTotalSecond = 0;
      }
    },
  },
};
</script>

<style lang="scss">
.ryouSelectPCStyle1 {
  width: 100%;
  height: 40px;
}

.ryouSelectMobileStyle1 {
  width: 100%;
  height: 40px;
}

.ryouSelectPCStyle2 {
  width: 40%;
  height: 40px;
}

.ryouSelectPCStyle3 {
  width: 55%;
  height: 40px;
  float: right;
}

.ryouSelectMobileStyle3 {
  width: 100%;
  height: 40px;
  float: right;
}

.nopadding {
  padding: 0px;
}

.noBotPadding {
  padding-bottom: 0px;
}

.noTopBotPadding {
  padding: 0px 14px;
}

.noTopBotPaddingMobile {
  padding: 0px 5px;
}

.noRigPadding {
  padding-right: 0px;
}

.mask {
  box-sizing: border-box;
  border: 1px solid #9e9e9e !important;
  background-color: #bebebe !important;
}

.smallCalendarWeekListStyle {
  width: 25px !important;
  height: 25px !important;
}

.table_style td,
th {
  padding: 2px;
  font-size: 16px;
}

.table_style {
  border-collapse: collapse;
  width: 80%;
  text-align: center;
}

.border {
  border: solid 1px;
}

// 2024.10.24 kouta.noborisaka 三井化学（市原工場）:スタイルの定義 Start
.scroll-area {
  min-width: 1000px; // 要素の最小幅を1000pxとする
}

.v-event {
  height: auto !important; // 要素の高さを可変にする
}
// 2024.10.24 kouta.noborisaka 三井化学（市原工場）:スタイルの定義 End
</style>
